import React, { PropsWithChildren } from 'react';

import { BaseContainer } from '@/layout/components';
import { BaseContainerProps } from '@/layout/components/BaseContainer';

export type BlankLayoutProps = PropsWithChildren<Omit<BaseContainerProps, 'children'>>;

export const BlankLayout: React.FC<BlankLayoutProps> = ({ height, ...props }: BlankLayoutProps) => (
  <BaseContainer height={height || 'unset'} {...props} />
);

export default BlankLayout;
